import type React from 'react';
import { useTranslation } from 'react-i18next';

import { company } from '~/company/Company';
import Icon from '~/components/Icon/Icon';
import { useIntercom } from '~/hooks/useIntercom';

interface FooterSupportButtonProps {
  className?: string;
}

export const FooterSupportButton = ({
  className,
}: FooterSupportButtonProps) => {
  const { t } = useTranslation();
  const { openMessenger, isOpening } = useIntercom();

  if (!company.config.phoneNumber) return null;

  return (
    <button
      type="button"
      disabled={isOpening}
      className={className}
      onClick={(e) => {
        e.preventDefault();
        openMessenger();
      }}
    >
      {isOpening ? (
        <span className="spinner _white" />
      ) : (
        <Icon type="message_text_circle" />
      )}
      {t('support')}
    </button>
  );
};
